import React from "react";
import classnames from "classnames";
import { CircularProgress } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

import { CurrencyType, CustomComponent } from "store/types";
import { useActionHook } from "hooks";
// import { ReactComponent as Tick } from "../../../assets/icons/tick.svg";
import { ReactComponent as USDIcon } from "../../../assets/icons/usd.svg";
import { ReactComponent as EURIcon } from "../../../assets/icons/eur.svg";
// import { ReactComponent as BTCIcon } from "../../../assets/icons/bitcoin.svg";
import { ReactComponent as JPYIcon } from "../../../assets/icons/japaneses-yen.svg";
import { ReactComponent as GBPIcon } from "../../../assets/icons/pound-sterling.svg";
import { ReactComponent as AUDIcon } from "../../../assets/icons/austrian-dollar.svg";
import { ReactComponent as DKKIcon } from "../../../assets/icons/danish-krone.svg";
import { ReactComponent as CADIcon } from "../../../assets/icons/canadian-dollar.svg";
import { ReactComponent as ILSIcon } from "../../../assets/icons/shekel.svg";
// import { ReactComponent as CHYIcon } from "../../../assets/icons/chinese-yuan.svg";
import { ReactComponent as CHFIcon } from "../../../assets/icons/swiss-franc.svg";
import { ReactComponent as PLNIcon } from "../../../assets/icons/polish-zloty.svg";
// import { ReactComponent as NISIcon } from "../../../assets/icons/shekel.svg";
import { IDropdownHead, IDropdownOption, ThemeType } from "./dropdown-types";
import { MaterialTooltip } from "components/tooltips/MaterialTooltip";

export const currencyIcons: Record<CurrencyType, CustomComponent> = {
  USD: USDIcon,
  EUR: EURIcon,
  // BTC: BTCIcon,
  JPY: JPYIcon,
  GBP: GBPIcon,
  AUD: AUDIcon,
  // NIS: NISIcon,
  ILS: ILSIcon,
  CAD: CADIcon,
  DKK: DKKIcon,
  NZD: USDIcon,
  // CNY: CHYIcon,
  CHF: CHFIcon,
  PLN: PLNIcon
};

export const OptionGeneral: React.FC<IDropdownOption> = ({ onClick, value, isSelected, theme = "standard" }) => {
  const { loading, action } = useActionHook(async () => await onClick());

  return (
    <div
      onClick={() => (loading ? null : action())}
      className={classnames("option", `option--${theme}`, "scale-click", {
        "option--selected": isSelected,
        "flex-row-fc-fc": loading
      })}
    >
      {loading ? <CircularProgress size={20} /> : <span className="one-row-text">{value}</span>}
    </div>
  );
};

export const OptionBlueLight: React.FC<IDropdownOption> = ({ onClick, value, isSelected, theme = "standard" }) => {
  const { loading, action } = useActionHook(async () => await onClick());

  return (
    <MaterialTooltip isShow placement="left" title={value}>
      <div
        onClick={() => (loading ? null : action())}
        className={classnames("option", "flex-row-sb-fc", `option--${theme}`, "scale-click", {
          "option--selected": isSelected
        })}
      >
        <span className="one-row-text">{value}</span>
      </div>
    </MaterialTooltip>
  );
};

export const OptionCurrency: React.FC<IDropdownOption> = ({ onClick, value, isSelected, theme = "standard" }) => {
  const { loading, action } = useActionHook(async () => await onClick());
  if (typeof value === "string") {
    const Icon: CustomComponent = currencyIcons[value as CurrencyType];
    return (
      <div
        onClick={() => (loading ? null : action())}
        className={classnames("option", "flex-row-sb-fc", `option--${theme}`, "scale-click", {
          "option--selected": isSelected
        })}
      >
        <div className="flex-row-fs-fc">
          {Icon ? (
            <div className="currency-icon__wrapper">
              <Icon />
            </div>
          ) : (
            "#"
          )}
          <span className="one-row-text">{value}</span>
        </div>
      </div>
    );
  }
  return <></>;
};

export const HeadGeneral: React.FC<IDropdownHead> = ({
  onClick,
  isOpen,
  placeholder,
  value,
  theme = "standard",
  disabled
}) => {
  return (
    <div
      onClick={onClick}
      className={classnames("head", `head--${theme}`, "flex-row-sb-fc", {
        "head--open": isOpen,
        "scale-click": !disabled,
        [`head--${theme}--open`]: isOpen
      })}
    >
      {value ? (
        <span className="value one-row-text">{value}</span>
      ) : (
        <span className="placeholder one-row-text">{placeholder}</span>
      )}
      <div className="flex-row-fc-fc">
        <ArrowDropDownIcon
          sx={{ color: "#5d7782;" }}
          className={classnames("rotate-180", {
            "rotate-180--active": isOpen
          })}
        />
      </div>
    </div>
  );
};

export const HeadBlueLight: React.FC<IDropdownHead> = ({
  onClick,
  isOpen,
  placeholder,
  value,
  theme = "standard",
  disabled
}) => {
  return (
    <div
      onClick={onClick}
      className={classnames("head", `head--${theme}`, "flex-row-sb-fc", {
        "head--open": isOpen,
        "scale-click": !disabled,
        [`head--${theme}--open`]: isOpen
      })}
    >
      {value ? (
        <span className="value one-row-text">{value}</span>
      ) : (
        <span className="placeholder one-row-text">{placeholder}</span>
      )}
      <div className="flex-row-fc-fc">
        <ArrowDropDownIcon
          sx={{ color: "#5d7782;" }}
          className={classnames("rotate-180", {
            "rotate-180--active": isOpen
          })}
        />
      </div>
    </div>
  );
};

export const HeadCurrency: React.FC<IDropdownHead> = ({
  onClick,
  isOpen,
  placeholder,
  value,
  theme = "standard",
  disabled
}) => {
  return (
    <div
      onClick={onClick}
      className={classnames("head", `head--${theme}`, "flex-row-sb-fc", {
        "head--open": isOpen,
        "scale-click": !disabled,
        [`head--${theme}--open`]: isOpen
      })}
    >
      {value ? (
        <span className="value one-row-text">{value}</span>
      ) : (
        <span className="placeholder one-row-text">{placeholder}</span>
      )}
      <div className="flex-row-fc-fc">
        <ArrowDropDownIcon
          sx={{ color: "#5d7782;" }}
          className={classnames("rotate-180", {
            "rotate-180--active": isOpen
          })}
        />
      </div>
    </div>
  );
};

export type OptionsHashType = Record<ThemeType, CustomComponent<IDropdownOption>>;

export const OptionsHash: OptionsHashType = {
  standard: OptionGeneral,
  ["blue-light"]: OptionBlueLight,
  currency: OptionCurrency
};

type HeadsHashType = Record<ThemeType, CustomComponent<IDropdownHead>>;

export const HeadsHash: HeadsHashType = {
  standard: HeadGeneral,
  ["blue-light"]: HeadBlueLight,
  currency: HeadCurrency
};
